import React, { useContext } from 'react';
import styled from 'styled-components';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  margin-left: 50px;
  border: 1px solid #979797;
  border-radius: 3px;
  height: 28px;
  color: #fff;
  display: flex;
  align-items: center;
  font-size: 13px;
  padding: 0 12px;
  position: relative;
  width: 90px;
  cursor: pointer;
  &:hover {
    .selected {
      &:after {
        transform: rotate(180deg);
      }
    }
    .holder {
      display: block;
    }
  }
  .selected {
    font-weight: 600;
    position: relative;
    width: 100%;
    &:after {
      position: absolute;
      content: ' ';
      right: -4px;
      top: 6px;
      width: 0; 
      height: 0; 
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 4px solid #979797;
    }
  }
  .holder {
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    @media (min-width: 980px) {
      top: 28px;
    }
    @media (max-width: 980px) {
      bottom: 43px;
    }
    z-index: 6;
    ul {
      position: relative;
      width: 100%;
      background: #000;
      margin: 0;
      padding: 3px 0 0;
      top: -3px;
      @media (min-width: 980px) {
        border: 1px solid #979797;
        border-radius: 0 0 3px 3px;
        left: -1px;
        border-top: 0;
      }
      li {
        display: block;
        padding: 6px 12px;
        @media (min-width: 789px) {
          border-top: 1px solid #fff;
        }
        @media (max-width: 789px) {
          padding: 14px 12px;
          border-bottom: 1px solid #fff;
        }
      }
    }
  }
`

const LangSelect = () => {
  const { language, setLanguage } = useContext(LanguageContext);
  return (
    <Container id="lang-select">
      <span className="selected">
        { language === 'pt-br' && 'Português' }
        { language === 'en-us' && 'English' }
        { language === 'es-es' && 'Español' }
      </span>
      <i></i>
      <div className="holder">
        <ul>
          <li onClick={ () => setLanguage('pt-br') } >
            <span>Português</span>
          </li>
          <li onClick={ () => setLanguage('en-us') } >
            <span>English</span>
          </li>
          <li onClick={ () => setLanguage('es-es') } >
            <span>Español</span>
          </li>
        </ul>
      </div>
    </Container>
  )
}

export default LangSelect;
